import Image from "next/image";
import { useSelector, useDispatch } from "react-redux";
import Title from "../../components/Title";
import { reset } from "../../redux/cardSlice";
import { getSession, useSession } from "next-auth/react";
import { useRouter } from "next/router";

export default function Index() {
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(reset());
  };

  const { push } = useRouter();
  const { data: session, status } = useSession({
    required: true,
    onUnauthenticated() {
      push('/auth/login')
    }
  });

  if (status === 'loading') {
    return 'Loading or not authenticated...'
  }

  return (
    <div>
      { session } && <div>you signed in {session.user.name}</div>
      <div className="flex justify-between place-content-center">
        <div className="flex flex-1 items-center p-10">
          <table className="w-full text-sm text-center text-gray-500 ">
            <thead className="text-xs text-gray-400 uppercase bg-gray-700">
              <tr>
                <th scope="col" className="py-3 px-6 hover:text-white transition-all">PRODUCT</th>
                <th scope="col" className="py-3 px-6 hover:text-white transition-all">EXTRAS</th>
                <th scope="col" className="py-3 px-6 hover:text-white transition-all">PRICE</th>
                <th scope="col" className="py-3 px-6 hover:text-white transition-all">QUANTITY</th>
              </tr>
            </thead>
            <tbody>
              {cart.products.map((product) => (
                <tr key={product.id} className="bg-secondary border-gray-700 hover:bg-primary transition-all overflow-x-auto w-full">
                  <td className="py-4 px-6 font-medium whitespace-nowrap text-white flex items-center gap-x-1 justify-center min-w-[750px]">
                    <Image src="/images/sebzelipizza.png" alt="" width="50" height="50" />
                    <span>{product.name}</span>
                  </td>
                  <td className="py-4 px-6 font-medium whitespace-nowrap text-white transition-all">
                    {product.extras.map((item) => (
                      <span key={item.id}>
                        {item.name}
                      </span>
                    ))}
                  </td>
                  <td className="py-4 px-6 font-medium whitespace-nowrap text-white transition-all">{product.price}$</td>
                  <td className="py-4 px-6 font-medium whitespace-nowrap text-white transition-all">{product.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-secondary flex flex-col gap-y-10 place-content-center text-white h-screen p-10">
          <Title baslik="CART TOTAL" addClass="text-white text-[40px] font-dancing" />
          <div className="flex flex-col">
            <span>Subtotal: ${cart.total}</span>
            <span>Discount: $0.00</span>
            <span>Total: ${cart.total}</span>
          </div>
          <button className="text-white text-sm font-medium bg-primary py-2 px-4 rounded-3xl" onClick={handleClick}>Sepeti Boşalt</button>

        </div>
      </div>
    </div>
  )
}


export async function getServerSideProps({ req }) {
  const session = await getSession({ req });

  if (session) {
    return {
      redirect: {
        destination: "/auth/login",
        permanent: false,
      },
    };
  }

  return {
    props: {session},
  };
}
